import { DEMO_ACADEMY_ID } from "./mockPlayers";
import {
  demoAcademyLogo,
  demoPlayerPhoto,
  demoPlayerPhotoPair,
  demoTrainerPhotoPair,
} from "./demoImages";
import { mockTrainers } from "./mockTrainers";
import { demoApi, matchesDemoSearch } from "./demoLocale";

export const STRUCTURE_ACADEMY_NORTH_ID = "00000000-0000-0000-0000-000000000011";
export const STRUCTURE_ACADEMY_SOUTH_ID = "00000000-0000-0000-0000-000000000012";
export const STRUCTURE_ACADEMY_WOMEN_ID = "00000000-0000-0000-0000-000000000013";

const demoAddress = (city: string, street: string, postCode: string) => ({
  Country: 0,
  Region: "",
  City: city,
  Street: street,
  BuildingNumber: "1",
  FlatNumber: "",
  PostCode: postCode,
});

export const mockStructureAcademies = [
  {
    AcademyId: DEMO_ACADEMY_ID,
    Name: "Klub piłkarski",
    PhotoFilePath: demoAcademyLogo("Klub piłkarski"),
    NIP: "1234567890",
    IsActivate: true,
    IsMainBranch: true,
    Address: demoAddress("Kraków", "ul. Sportowa", "30-001"),
    Type: 0,
    Visibility: 1,
    AccessStatus: 3,
  },
  {
    AcademyId: STRUCTURE_ACADEMY_NORTH_ID,
    Name: "Oddział Akademii",
    PhotoFilePath: demoAcademyLogo("Oddział Akademii"),
    NIP: "9876543210",
    IsActivate: true,
    IsMainBranch: false,
    Address: demoAddress("Warszawa", "ul. Piłkarska", "00-001"),
    Type: 0,
    Visibility: 1,
    AccessStatus: 2,
  },
  {
    AcademyId: STRUCTURE_ACADEMY_SOUTH_ID,
    Name: "Oddział Akademii - Zachodni",
    PhotoFilePath: demoAcademyLogo("Oddział Akademii - Zachodni"),
    NIP: "5647382910",
    IsActivate: true,
    IsMainBranch: false,
    Address: demoAddress("Katowice", "ul. Młodzieżowa", "40-001"),
    Type: 2,
    Visibility: 0,
    AccessStatus: 1,
  },
  {
    AcademyId: STRUCTURE_ACADEMY_WOMEN_ID,
    Name: "Sekcja kobieca",
    PhotoFilePath: demoAcademyLogo("Sekcja kobieca"),
    NIP: "6758493021",
    IsActivate: true,
    IsMainBranch: false,
    Address: demoAddress("Płock", "ul. Jasna", "09-400"),
    Type: 2,
    Visibility: 1,
    AccessStatus: 1,
  },
];

const grantTrainer = (trainerId: string, name: string, type = 0, isRootFolder = false) => ({
  TrainerId: trainerId,
  Name: name,
  ...demoTrainerPhotoPair(trainerId),
  IsRootFolder: isRootFolder,
  Type: type,
  CreatedAt: "2026-06-01T10:00:00Z",
});

const folderPlayer = (folderItemId: string, playerId: string, name: string, order: number) => ({
  FolderItemId: folderItemId,
  PlayerId: playerId,
  Name: name,
  PhotoFilePath: demoPlayerPhoto(playerId),
  Order: order,
  TransportType: 1,
});

const rootFolder = (folderId: string, name: string, items: ReturnType<typeof folderPlayer>[]) => ({
  FolderId: folderId,
  Name: name,
  ItemsCount: items.length,
  Items: items.map(({ FolderItemId, PlayerId, Name, PhotoFilePath }) => ({
    FolderItemId,
    PlayerId,
    Name,
    PhotoFilePath,
  })),
});

const FOLDERS = {
  krakowU15: "00000000-0000-0000-0000-000000001601",
  krakowU13: "00000000-0000-0000-0000-000000001602",
  krakowGk: "00000000-0000-0000-0000-000000001603",
  krakowCamp: "00000000-0000-0000-0000-000000001604",
  krakowU15Reserve: "00000000-0000-0000-0000-000000001605",
  warsawU14: "00000000-0000-0000-0000-000000001701",
  warsawU16: "00000000-0000-0000-0000-000000001702",
  warsawMlodzik: "00000000-0000-0000-0000-000000001703",
  warsawSmyki: "00000000-0000-0000-0000-000000001704",
  warsawElite: "00000000-0000-0000-0000-000000001705",
  katowiceYoung: "00000000-0000-0000-0000-000000001801",
  katowiceOrlik: "00000000-0000-0000-0000-000000001802",
  katowiceSquad: "00000000-0000-0000-0000-000000001803",
  katowicePrep: "00000000-0000-0000-0000-000000001804",
  katowiceSkrzatReserve: "00000000-0000-0000-0000-000000001806",
  plockTrampkarz: "00000000-0000-0000-0000-000000001901",
  plockMlodzik: "00000000-0000-0000-0000-000000001902",
};

export const mockRootFoldersByAcademy: Record<string, ReturnType<typeof rootFolder>[]> = {
  [DEMO_ACADEMY_ID]: [
    rootFolder(FOLDERS.krakowU15, "Pierwsza drużyna", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001611",
        "00000000-0000-0000-0000-000000000101",
        "Jan Kowalski",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001612",
        "00000000-0000-0000-0000-000000000102",
        "Adam Nowak",
        1
      ),
    ]),
    rootFolder(FOLDERS.krakowU13, "Rezerwy", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001621",
        "00000000-0000-0000-0000-000000000103",
        "Piotr Wiśniewski",
        0
      ),
    ]),
    rootFolder(FOLDERS.krakowGk, "Grupa obserwowana", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001631",
        "00000000-0000-0000-0000-000000000104",
        "Michał Zieliński",
        0
      ),
    ]),
  ],
  [STRUCTURE_ACADEMY_NORTH_ID]: [
    rootFolder(FOLDERS.warsawU14, "Trampkarz 2014", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001711",
        "00000000-0000-0000-0000-000000000201",
        "Kacper Malinowski",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001712",
        "00000000-0000-0000-0000-000000000202",
        "Filip Jankowski",
        1
      ),
    ]),
    rootFolder(FOLDERS.warsawU16, "U16 Liga", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001721",
        "00000000-0000-0000-0000-000000000203",
        "Oskar Mazur",
        0
      ),
    ]),
    rootFolder(FOLDERS.warsawMlodzik, "Młodzik", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001731",
        "00000000-0000-0000-0000-000000000301",
        "Nikodem Wójcik",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001732",
        "00000000-0000-0000-0000-000000000302",
        "Igor Szymański",
        1
      ),
    ]),
  ],
  [STRUCTURE_ACADEMY_SOUTH_ID]: [
    rootFolder(FOLDERS.katowiceYoung, "Młodzik 2013", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001811",
        "00000000-0000-0000-0000-000000000303",
        "Bartosz Krawczyk",
        0
      ),
    ]),
    rootFolder(FOLDERS.katowiceOrlik, "Orlik 2014", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001821",
        "00000000-0000-0000-0000-000000000401",
        "Mateusz Lis",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001822",
        "00000000-0000-0000-0000-000000000402",
        "Wiktor Pawlak",
        1
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001823",
        "00000000-0000-0000-0000-000000000403",
        "Szymon Dąbrowski",
        2
      ),
    ]),
    rootFolder(FOLDERS.katowiceSquad, "Skrzat 2015", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001831",
        "00000000-0000-0000-0000-000000000101",
        "Jan Kowalski",
        0
      ),
    ]),
    rootFolder(FOLDERS.katowicePrep, "Trampkarz 2017", []),
  ],
  [STRUCTURE_ACADEMY_WOMEN_ID]: [
    rootFolder(FOLDERS.plockTrampkarz, "Trampkarz", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001911",
        "00000000-0000-0000-0000-000000000701",
        "Zuzanna Kwiatkowska",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001912",
        "00000000-0000-0000-0000-000000000702",
        "Natalia Baran",
        1
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001913",
        "00000000-0000-0000-0000-000000000703",
        "Oliwia Sikora",
        2
      ),
    ]),
    rootFolder(FOLDERS.plockMlodzik, "Młodzik", [
      folderPlayer(
        "00000000-0000-0000-0000-000000001921",
        "00000000-0000-0000-0000-000000000704",
        "Lena Tomaszewska",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001922",
        "00000000-0000-0000-0000-000000000705",
        "Maja Wróblewska",
        1
      ),
    ]),
  ],
};

const subFolder = (folderId: string, name: string, itemsCount = 0) => ({
  FolderId: folderId,
  Name: name,
  ItemsCount: itemsCount,
  Items: [],
  SubFolders: [],
  GrantTrainers: [],
});

export const mockFolderDetails: Record<string, any> = {
  [FOLDERS.krakowU15]: {
    FolderId: FOLDERS.krakowU15,
    Name: "Pierwsza drużyna",
    ItemsCount: 2,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001611",
        "00000000-0000-0000-0000-000000000101",
        "Jan Kowalski",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001612",
        "00000000-0000-0000-0000-000000000102",
        "Adam Nowak",
        1
      ),
    ],
    SubFolders: [],
    GrantTrainers: [
      grantTrainer("00000000-0000-0000-0000-000000000201", "Marek Lewandowski", 0, true),
      grantTrainer("00000000-0000-0000-0000-000000000202", "Tomasz Kamiński", 1),
    ],
  },
  [FOLDERS.krakowU15Reserve]: {
    FolderId: FOLDERS.krakowU15Reserve,
    Name: "Pierwsza drużyna — rezerwa",
    ItemsCount: 0,
    Items: [],
    SubFolders: [],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000203", "Krzysztof Zieliński", 2)],
  },
  [FOLDERS.krakowU13]: {
    FolderId: FOLDERS.krakowU13,
    Name: "Rezerwy",
    ItemsCount: 1,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001621",
        "00000000-0000-0000-0000-000000000103",
        "Piotr Wiśniewski",
        0
      ),
    ],
    SubFolders: [subFolder("00000000-0000-0000-0000-000000001606", "Treningi indywidualne")],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000501", "Robert Górski", 0)],
  },
  [FOLDERS.krakowGk]: {
    FolderId: FOLDERS.krakowGk,
    Name: "Grupa obserwowana",
    ItemsCount: 1,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001631",
        "00000000-0000-0000-0000-000000000104",
        "Michał Zieliński",
        0
      ),
    ],
    SubFolders: [],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000502", "Damian Wróbel", 0)],
  },

  [FOLDERS.warsawU14]: {
    FolderId: FOLDERS.warsawU14,
    Name: "Trampkarz 2014",
    ItemsCount: 2,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001711",
        "00000000-0000-0000-0000-000000000201",
        "Kacper Malinowski",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001712",
        "00000000-0000-0000-0000-000000000202",
        "Filip Jankowski",
        1
      ),
    ],
    SubFolders: [],
    GrantTrainers: [
      grantTrainer("00000000-0000-0000-0000-000000000503", "Łukasz Jasiński", 3),
      grantTrainer("00000000-0000-0000-0000-000000000603", "Artur Sobczak", 2),
    ],
  },
  [FOLDERS.warsawU16]: {
    FolderId: FOLDERS.warsawU16,
    Name: "U16 Liga",
    ItemsCount: 1,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001721",
        "00000000-0000-0000-0000-000000000203",
        "Oskar Mazur",
        0
      ),
    ],
    SubFolders: [],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000201", "Marek Lewandowski", 0)],
  },
  [FOLDERS.warsawMlodzik]: {
    FolderId: FOLDERS.warsawMlodzik,
    Name: "Młodzik",
    ItemsCount: 2,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001731",
        "00000000-0000-0000-0000-000000000301",
        "Nikodem Wójcik",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001732",
        "00000000-0000-0000-0000-000000000302",
        "Igor Szymański",
        1
      ),
    ],
    SubFolders: [subFolder(FOLDERS.warsawSmyki, "Smyki")],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000202", "Tomasz Kamiński", 1)],
  },
  [FOLDERS.warsawSmyki]: {
    FolderId: FOLDERS.warsawSmyki,
    Name: "Smyki",
    ItemsCount: 0,
    Items: [],
    SubFolders: [],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000203", "Krzysztof Zieliński", 2)],
  },

  [FOLDERS.katowiceYoung]: {
    FolderId: FOLDERS.katowiceYoung,
    Name: "Młodzik 2013",
    ItemsCount: 1,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001811",
        "00000000-0000-0000-0000-000000000303",
        "Bartosz Krawczyk",
        0
      ),
    ],
    SubFolders: [subFolder("00000000-0000-0000-0000-000000001805", "Grupa rezerwowa")],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000501", "Robert Górski", 0)],
  },
  [FOLDERS.katowiceOrlik]: {
    FolderId: FOLDERS.katowiceOrlik,
    Name: "Orlik 2014",
    ItemsCount: 3,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001821",
        "00000000-0000-0000-0000-000000000401",
        "Mateusz Lis",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001822",
        "00000000-0000-0000-0000-000000000402",
        "Wiktor Pawlak",
        1
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001823",
        "00000000-0000-0000-0000-000000000403",
        "Szymon Dąbrowski",
        2
      ),
    ],
    SubFolders: [],
    GrantTrainers: [
      grantTrainer("00000000-0000-0000-0000-000000000502", "Damian Wróbel", 1),
      grantTrainer("00000000-0000-0000-0000-000000000601", "Marcin Ostrowski", 0),
    ],
  },
  [FOLDERS.katowiceSquad]: {
    FolderId: FOLDERS.katowiceSquad,
    Name: "Skrzat 2015",
    ItemsCount: 1,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001831",
        "00000000-0000-0000-0000-000000000101",
        "Jan Kowalski",
        0
      ),
    ],
    SubFolders: [subFolder(FOLDERS.katowiceSkrzatReserve, "Skrzat rezerwy", 2)],
    GrantTrainers: [
      grantTrainer("00000000-0000-0000-0000-000000000503", "Łukasz Jasiński", 3, true),
    ],
  },
  [FOLDERS.katowiceSkrzatReserve]: {
    FolderId: FOLDERS.katowiceSkrzatReserve,
    Name: "Skrzat rezerwy",
    ItemsCount: 2,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001841",
        "00000000-0000-0000-0000-000000000506",
        "Patryk Góra",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001842",
        "00000000-0000-0000-0000-000000000507",
        "Fabian Tomczyk",
        1
      ),
    ],
    SubFolders: [],
    GrantTrainers: [
      grantTrainer("00000000-0000-0000-0000-000000000505", "Dominik Król", 3),
      grantTrainer("00000000-0000-0000-0000-000000000502", "Damian Wróbel", 1),
    ],
  },
  [FOLDERS.katowicePrep]: {
    FolderId: FOLDERS.katowicePrep,
    Name: "Trampkarz 2017",
    ItemsCount: 0,
    Items: [],
    SubFolders: [],
    GrantTrainers: [
      grantTrainer("00000000-0000-0000-0000-000000000602", "Grzegorz Michalski", 1),
      grantTrainer("00000000-0000-0000-0000-000000000603", "Artur Sobczak", 2),
    ],
  },

  [FOLDERS.plockTrampkarz]: {
    FolderId: FOLDERS.plockTrampkarz,
    Name: "Trampkarz",
    ItemsCount: 3,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001911",
        "00000000-0000-0000-0000-000000000701",
        "Zuzanna Kwiatkowska",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001912",
        "00000000-0000-0000-0000-000000000702",
        "Natalia Baran",
        1
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001913",
        "00000000-0000-0000-0000-000000000703",
        "Oliwia Sikora",
        2
      ),
    ],
    SubFolders: [],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000201", "Marek Lewandowski", 0)],
  },
  [FOLDERS.plockMlodzik]: {
    FolderId: FOLDERS.plockMlodzik,
    Name: "Młodzik",
    ItemsCount: 2,
    Items: [
      folderPlayer(
        "00000000-0000-0000-0000-000000001921",
        "00000000-0000-0000-0000-000000000704",
        "Lena Tomaszewska",
        0
      ),
      folderPlayer(
        "00000000-0000-0000-0000-000000001922",
        "00000000-0000-0000-0000-000000000705",
        "Maja Wróblewska",
        1
      ),
    ],
    SubFolders: [],
    GrantTrainers: [grantTrainer("00000000-0000-0000-0000-000000000202", "Tomasz Kamiński", 1)],
  },
};

export const mockAvailablePlayersByAcademy: Record<
  string,
  Array<{
    PlayerId: string;
    Name: string;
    PhotoFilePath: string;
    PhotoFilePathMin: string;
    Level?: number;
  }>
> = {
  [DEMO_ACADEMY_ID]: [],
  [STRUCTURE_ACADEMY_NORTH_ID]: [
    {
      PlayerId: "00000000-0000-0000-0000-000000000504",
      Name: "Alan Michalski",
      ...demoPlayerPhotoPair("00000000-0000-0000-0000-000000000504"),
      Level: 0,
    },
    {
      PlayerId: "00000000-0000-0000-0000-000000000505",
      Name: "Dominik Król",
      ...demoPlayerPhotoPair("00000000-0000-0000-0000-000000000505"),
      Level: 1,
    },
  ],
  [STRUCTURE_ACADEMY_SOUTH_ID]: [
    {
      PlayerId: "00000000-0000-0000-0000-000000000508",
      Name: "Olivier Bąk",
      ...demoPlayerPhotoPair("00000000-0000-0000-0000-000000000508"),
      Level: 1,
    },
  ],
  [STRUCTURE_ACADEMY_WOMEN_ID]: [
    {
      PlayerId: "00000000-0000-0000-0000-000000000706",
      Name: "Amelia Nowicka",
      ...demoPlayerPhotoPair("00000000-0000-0000-0000-000000000706"),
      Level: 0,
    },
    {
      PlayerId: "00000000-0000-0000-0000-000000000707",
      Name: "Hanna Pietrzak",
      ...demoPlayerPhotoPair("00000000-0000-0000-0000-000000000707"),
      Level: 1,
    },
  ],
};

export const mockStructureSearchResults = {
  Folders: [
    {
      FolderId: FOLDERS.krakowU15,
      FolderName: "Pierwsza drużyna",
      ItemId: "00000000-0000-0000-0000-000000000101",
      Name: "Jan Kowalski",
      Type: 0,
    },
    {
      FolderId: FOLDERS.krakowGk,
      FolderName: "Grupa obserwowana",
      ItemId: "00000000-0000-0000-0000-000000000104",
      Name: "Michał Zieliński",
      Type: 0,
    },
    {
      FolderId: FOLDERS.warsawU14,
      FolderName: "Trampkarz 2014",
      ItemId: "00000000-0000-0000-0000-000000000201",
      Name: "Kacper Malinowski",
      Type: 0,
    },
    {
      FolderId: FOLDERS.katowiceOrlik,
      FolderName: "Orlik 2014",
      ItemId: "00000000-0000-0000-0000-000000000401",
      Name: "Mateusz Lis",
      Type: 0,
    },
    {
      FolderId: FOLDERS.plockTrampkarz,
      FolderName: "Trampkarz",
      ItemId: "00000000-0000-0000-0000-000000000701",
      Name: "Zuzanna Kwiatkowska",
      Type: 0,
    },
    {
      FolderId: FOLDERS.plockMlodzik,
      FolderName: "Młodzik",
      ItemId: "00000000-0000-0000-0000-000000000704",
      Name: "Lena Tomaszewska",
      Type: 0,
    },
  ],
};

const paginated = <T>(items: T[]) => ({
  Items: items,
  TotalCount: items.length,
  PageNumber: 1,
  TotalPages: 1,
  HasPreviousPage: false,
  HasNextPage: false,
});

export const getMockAcademyWithBranchesResponse = (searchQuery?: string) => {
  const search = searchQuery?.trim().toLowerCase() ?? "";
  const items = search
    ? mockStructureAcademies.filter(
        (academy) =>
          matchesDemoSearch(academy.Name, search) ||
          matchesDemoSearch(academy.Address.City, search)
      )
    : mockStructureAcademies;

  return paginated(items);
};

export const getMockRootFoldersResponse = (academyId?: string) => {
  const items = mockRootFoldersByAcademy[academyId ?? ""] ?? [];
  return paginated(items);
};

export const getMockAvailablePlayersResponse = (academyId?: string) => {
  const items = mockAvailablePlayersByAcademy[academyId ?? ""] ?? [];
  return paginated(items);
};

export const getMockFolderDetailResponse = (folderId?: string) =>
  mockFolderDetails[folderId ?? ""] ?? mockFolderDetails[FOLDERS.krakowU15];

export const getMockFolderDetailApiResponse = (_academyId?: string, folderId?: string) => ({
  Data: getMockFolderDetailResponse(folderId),
});

export const getMockRootFoldersApiResponse = demoApi((academyId?: string) => ({
  Data: getMockRootFoldersResponse(academyId),
}));

const ROOT_PARENT_FOLDER_ID = "00000000-0000-0000-0000-000000000000";

/**
 * Płaska lista folderów z ParentFolderId — wymagana przez formularz wydarzeń
 * (GetOwnFolders → budowa drzewa grup).
 */
export const getMockOwnFoldersResponse = demoApi((academyId?: string) => {
  const roots =
    mockRootFoldersByAcademy[academyId ?? ""] ??
    mockRootFoldersByAcademy[DEMO_ACADEMY_ID] ??
    [];

  const flat: Array<{
    FolderId: string;
    Name: string;
    ParentFolderId: string;
    ItemsCount?: number;
  }> = [];

  const pushFolder = (
    folder: {
      FolderId: string;
      Name: string;
      ItemsCount?: number;
      SubFolders?: Array<{
        FolderId: string;
        Name: string;
        ItemsCount?: number;
        SubFolders?: any[];
      }>;
    },
    parentId: string
  ) => {
    flat.push({
      FolderId: folder.FolderId,
      Name: folder.Name,
      ParentFolderId: parentId,
      ItemsCount: folder.ItemsCount,
    });

    const detail = mockFolderDetails[folder.FolderId];
    const subs = detail?.SubFolders ?? folder.SubFolders ?? [];
    subs.forEach((sub: any) => pushFolder(sub, folder.FolderId));
  };

  roots.forEach((root) => pushFolder(root, ROOT_PARENT_FOLDER_ID));
  return flat;
});

export const getMockOwnFoldersApiResponse = demoApi(async (academyId?: string) => ({
  Data: getMockOwnFoldersResponse(academyId),
}));

export const getMockAvailablePlayersApiResponse = demoApi((academyId?: string) => ({
  Data: getMockAvailablePlayersResponse(academyId),
}));

export const grantMockFolderToTrainer = async (
  _academyId: string,
  folderId: string,
  trainerId: string
) => {
  const detail = getMockFolderDetailResponse(folderId);
  if (!Array.isArray(detail.GrantTrainers)) {
    detail.GrantTrainers = [];
  }

  if (!detail.GrantTrainers.some((trainer: any) => trainer.TrainerId === trainerId)) {
    const trainer = mockTrainers.find((item) => item.TrainerId === trainerId);
    detail.GrantTrainers.push(
      grantTrainer(trainerId, trainer?.Name ?? "Trener demo", trainer?.Type ?? 0, false)
    );
  }

  mockFolderDetails[detail.FolderId] = detail;
  return { Success: true };
};

export const revokeMockFolderToTrainer = async (
  _academyId: string,
  folderId: string,
  trainerId: string
) => {
  const detail = getMockFolderDetailResponse(folderId);
  detail.GrantTrainers = (detail.GrantTrainers ?? []).filter(
    (trainer: any) => trainer.TrainerId !== trainerId
  );
  mockFolderDetails[detail.FolderId] = detail;
  return { Success: true };
};

export const getMockStructureSearchResponse = (searchQuery?: string, academyId?: string) => {
  const search = searchQuery?.trim().toLowerCase() ?? "";
  let folders = mockStructureSearchResults.Folders;

  if (academyId) {
    const academyFolderIds = new Set(
      (mockRootFoldersByAcademy[academyId] ?? []).map((folder) => folder.FolderId)
    );
    folders = folders.filter((item) => academyFolderIds.has(item.FolderId));
  }

  if (search) {
    folders = folders.filter(
      (item) =>
        matchesDemoSearch(item.Name, search) || matchesDemoSearch(item.FolderName, search)
    );
  }

  return { Folders: folders };
};

export const DEMO_STRUCTURE_ACADEMY_ID = DEMO_ACADEMY_ID;
